import i18next from "i18next";
import { getExtensionFile } from "./string";
import { MEDIA_DIMENSIONS, IMAGE_FORMATS } from "./constants";
import { GALLERY_TITLE_DIMENSIONS } from "../i18n/keysTranslations";

export const COMMON_RATIOS = [
  { ratio: 1, text: "1:1" },
  { ratio: 4 / 3, text: "4:3" },
  { ratio: 3 / 2, text: "3:2" },
  { ratio: 16 / 9, text: "16:9" },
  { ratio: 3 / 4, text: "3:4" },
  { ratio: 2 / 3, text: "2:3" },
  { ratio: 9 / 16, text: "9:16" },
  { ratio: 5 / 4, text: "5:4" },
  { ratio: 4 / 5, text: "4:5" },
];

export const formatDimensionsText = (dimensions) => {
  if (!dimensions || dimensions.width === 0 || dimensions.height === 0)
    return "";

  const { width, height } = dimensions;

  const aspectRatio = width / height;

  const tolerance = 0.02;
  const commonRatio = COMMON_RATIOS.find(
    (r) => Math.abs(aspectRatio - r.ratio) < tolerance
  );

  if (commonRatio) {
    return i18next.t(GALLERY_TITLE_DIMENSIONS, {
      width,
      height,
      ratio: commonRatio.text,
    });
  }

  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
  const divisor = gcd(width, height);
  let ratioWidth = width / divisor;
  let ratioHeight = height / divisor;

  if (ratioWidth > 50 || ratioHeight > 50) {
    const roundedRatio = Math.round(aspectRatio * 100) / 100;
    return i18next.t(GALLERY_TITLE_DIMENSIONS, {
      width,
      height,
      ratio: `${roundedRatio}:1`,
    });
  }

  return i18next.t(GALLERY_TITLE_DIMENSIONS, {
    width,
    height,
    ratio: `${ratioWidth}:${ratioHeight}`,
  });
};

const ASPECT_RATIO_4_5 = 4 / 5;
const TOLERANCE = 0.02;

export const isAspectRatio4x5 = (dimensions) => {
  if (!dimensions || dimensions.width === 0 || dimensions.height === 0) {
    return false;
  }
  const aspectRatio = dimensions.width / dimensions.height;
  return Math.abs(aspectRatio - ASPECT_RATIO_4_5) < TOLERANCE;
};

export const getDimensionCategory = (aspectRatio) => {
  if (Math.abs(aspectRatio - ASPECT_RATIO_4_5) < TOLERANCE) {
    return MEDIA_DIMENSIONS.feed;
  }

  if (Math.abs(aspectRatio - 1) < 0.02) return MEDIA_DIMENSIONS.square;
  if (aspectRatio > 1.1) return MEDIA_DIMENSIONS.horizontal;
  if (aspectRatio < 0.9) return MEDIA_DIMENSIONS.vertical;
  return MEDIA_DIMENSIONS.square;
};

export const getContentType = (url) => {
  if (!url || typeof url !== "string") {
    return "unknown";
  }

  const extension = getExtensionFile(url);

  if (IMAGE_FORMATS.includes(extension)) {
    return "image";
  }

  if (url.includes("googlesyndication.com")) {
    return "image";
  }

  return "video";
};

export const CAROUSEL_CARD_PREVIEW_MAX_HEIGHT = 470;
export const CAROUSEL_CARD_PREVIEW_DEFAULT_ASPECT_RATIO = 1;

export const getCarouselCardPreviewLayout = ({
  width,
  height,
  maxHeight = CAROUSEL_CARD_PREVIEW_MAX_HEIGHT,
}) => {
  const aspectRatio =
    width && height
      ? width / height
      : CAROUSEL_CARD_PREVIEW_DEFAULT_ASPECT_RATIO;

  const maxWidthPx = maxHeight * aspectRatio;

  return {
    aspectRatio,
    width: `min(100%, ${maxWidthPx}px)`,
    maxHeight,
  };
};
